import routes from "actions/routes";
import { generateReadActionCreator } from "actions/crudActionCreators";
import ACTION_NAMES from "actions/ACTION_NAMES";

export default {
    checkDuplicates: generateReadActionCreator(routes.API_CONTACT_DUPLICATES, ACTION_NAMES.CONTACT_DUPLICATES)
}
